import Line from './src/main'

Line.install = function (Vue) {
    Vue.components(Line.name, Line)
}

export default Line